import {
  ApolloClient,
  InMemoryCache,
  ApolloLink,
  HttpLink,
} from '@apollo/client'
import { get } from 'lodash'
import {
  CONFIG_KEYS,
  getClientConfigValue,
} from '../../../shared/helpers/config-helper'
import { GRAPHQL_V2_VERSION_NUMBER } from '../../constants'
import errorLink from './error-link'

export default function makeApolloClient({
  hydrateCacheFrom,
  schema,
  clientOpts = {},
  linkOpts = {},
}) {
  const makeHttpLink = uri => new HttpLink({ uri, ...linkOpts })
  const contentV1Uri = getClientConfigValue(
    CONFIG_KEYS.NEXT_PUBLIC_CONTENT_SERVICE
  )
  const contentV2Uri = getClientConfigValue(
    CONFIG_KEYS.NEXT_PUBLIC_CONTENT_SERVICE_V2
  )
  const httpLinkV1 = makeHttpLink(contentV1Uri)
  const httpLinkV2 = makeHttpLink(contentV2Uri)

  const serviceLink = ApolloLink.split(
    operation =>
      get(operation.getContext(), 'version', 1) === GRAPHQL_V2_VERSION_NUMBER,
    httpLinkV2,
    httpLinkV1
  )

  const introspectionToPossibleTypes = introspectionQueryResultData => {
    const possibleTypes = {}

    introspectionQueryResultData.__schema.types.forEach(supertype => {
      if (supertype.possibleTypes) {
        possibleTypes[supertype.name] = supertype.possibleTypes.map(
          subtype => subtype.name
        )
      }
    })

    return possibleTypes
  }

  const unhydratedCache = new InMemoryCache({
    possibleTypes: schema && introspectionToPossibleTypes(schema),
  })
  const cache = hydrateCacheFrom
    ? unhydratedCache.restore(hydrateCacheFrom)
    : unhydratedCache
  const link = ApolloLink.from([errorLink, serviceLink])
  return new ApolloClient({ link, cache, ...clientOpts })
}
